"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_1 = require("./styled");

var Flips;

(function (Flips) {
  Flips["None"] = "none";
  Flips["Horizontal"] = "horizontal";
  Flips["Vertical"] = "vertical";
  Flips["Both"] = "both";
})(Flips = exports.Flips || (exports.Flips = {}));
/**
 * Content block - use for adding content
 *
 * @param {Object} props Component properties
 * @param {string | ReactNode} props.children Child components
 * @param {string | ReactNode} [props.aside] Side elements
 * @param {string} [props.flip] Flip content/aside horizontal, vertical or both
 */


var ContentBlock = function ContentBlock(_a) {
  var children = _a.children,
      _a$aside = _a.aside,
      aside = _a$aside === void 0 ? undefined : _a$aside,
      _a$flip = _a.flip,
      flip = _a$flip === void 0 ? Flips.None : _a$flip,
      rest = __rest(_a, ["children", "aside", "flip"]);

  return react_1["default"].createElement(styled_1.StyledContentBlock, Object.assign({
    aside: typeof aside !== "undefined",
    flip: flip
  }, rest), aside ? react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(styled_1.Content, null, children), react_1["default"].createElement(styled_1.Content, null, aside)) : children);
};

ContentBlock.Flips = Flips;
exports["default"] = ContentBlock;